import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgConfusedSelectedEmojiSecondary from './svgs/ConfusedSelectedEmojiSecondary.js';
import SvgConfusedSelectedEmoji from './svgs/ConfusedSelectedEmoji.js';
import { useIcon } from '../../shared-components/icon/index.js';

var confusedSelectedEmoji = (props => useIcon(SvgConfusedSelectedEmoji, SvgConfusedSelectedEmojiSecondary, props));

export { confusedSelectedEmoji as default };
